import { defineStore } from 'pinia'
import type Building from '@/types/building'
import type { ApartmentChooserDataV5 } from '@qispace/vue3-player'

export const useBuildingStore = defineStore('buildingStore', () => {
    const buildings = ref<Building[]>([])
    const building = ref<Building | null>(null)
    const apartmentChooserData = ref<ApartmentChooserDataV5 | null>(null)

    const activeBuildings = computed(() => {
        return buildings.value.filter((b) => b.active)
    })

    const buildingDatasheetNotes = ref<Array<object> | null>(null)

    // TODO: type for scenedata
    const buildingSceneData = ref<any>(null)

    const fetchBuildings = async (projectSlug: string): Promise<void> => {
        const { PUBLIC_API_URL, fetchData } = useAPI()
        buildings.value = await fetchData(`${PUBLIC_API_URL}/${projectSlug}/slug/building`)
    }

    const fetchBuilding = async (projectSlug: string, buildingSlug: string): Promise<void> => {
        const { PUBLIC_API_URL, fetchData } = useAPI()
        building.value = await fetchData(
            `${PUBLIC_API_URL}/${projectSlug}/slug/building/${buildingSlug}/slug`
        )
        apartmentChooserData.value = building.value.apartmentChooserData
    }

    const fetchBuildingDatasheetNotes = async (
        projectSlug: string,
        buildingSlug: string
    ): Promise<void> => {
        const { PUBLIC_API_URL, fetchData } = useAPI()
        buildingDatasheetNotes.value = await fetchData(
            `${PUBLIC_API_URL}/${projectSlug}/slug/building/${buildingSlug}/slug/apartmentDatasheetNote`
        )
    }

    const fetchBuildingSceneData = async (
        projectSlug: string,
        buildingSlug: string
    ): Promise<void> => {
        const { PUBLIC_API_URL, fetchData } = useAPI()
        buildingSceneData.value = await fetchData(
            `${PUBLIC_API_URL}/${projectSlug}/slug/building/${buildingSlug}/slug/scenedata`
        )
    }

    const setCurrentBuilding = (buildingSlug: string) => {
        building.value = buildings.value.find((item: Building) => item.slug === buildingSlug)
    }

    const getBuildingSplashImage = (projectSlug, buildingSlug) => {
        const { cdn } = useCDN()

        if (buildingSlug) {
            return `${cdn}/content/${projectSlug}/splash/${buildingSlug}.jpg`
        }

        return buildingPlaceholderImage()
    }

    // TODO: project placeholder image
    const buildingPlaceholderImage = () => {
        const { cdn } = useCDN()
        return `${cdn}/placeholders/building-placeholder.png`
    }
    const getBuildingById = computed(() => {
        return (buildingId) => {
            return buildings.value.find((item: Building) => item.id === buildingId)
        }
    })

    return {
        buildings: activeBuildings,
        building,
        buildingSceneData,
        buildingDatasheetNotes,
        apartmentChooserData,
        fetchBuildings,
        fetchBuilding,
        fetchBuildingSceneData,
        fetchBuildingDatasheetNotes,
        setCurrentBuilding,
        buildingPlaceholderImage,
        getBuildingById,
        getBuildingSplashImage
    }
})
